import { toast } from 'react-toastify';
import { Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import React, { useEffect, useState } from "react";
import SideBar from "../commanComponents/sidebar/sidebar";

import "./academicDetailCourse.css";
import { clearData } from '../../utils/localStorage';
import { sidebarNavItems, ROUTES } from "../../constant";
import { getAcademicCourseService, downloadCertificateService } from "../../modules/services";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import PrimaryButton from '../commanComponents/primaryButton/primaryButton';


const AcademicDetailCourse = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    let { slug } = useParams();

    useEffect(() => {
        (async () => {
            const responseData = await getAcademicCourseService(slug, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [slug]);

    const handleStartButton = () => { 
        navigate(ROUTES.ACADEMIC_COURSE_DETAIL + "/" + slug + "/lesson/" + data.course_progress.lesson);
    }

    const handleDownloadCertificate = () => { 
        try {
            downloadCertificateService(slug, {})
                .then((res) => {
                    setIsLoading(false);
                    const downloadUrl = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', 'file.png');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                
                }).catch((error) => {
                    setIsLoading(false);
                    toast.error(error.response.data.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                })
        } catch (error) {
            setIsLoading(false);
            toast.error(error.response.data.message[0], {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    }

    return (
        <div className='academic-detail-courses-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.academicCourses} />
            <div className='academic-detail-courses-side-container'>
                <TopNavigation activeItem={sidebarNavItems.academicCourses} />
                
                <div className='row academic-detail-courses-filter-container'>
                    <div className='academic-detail-courses-filter-inner-div'>
                        {
                            data && data.course_progress.status === "Completed" &&
                                <PrimaryButton
                                    text="Get Certificate"
                                    customStyle={{ marginRight: "10px" }}
                                    isLoading={isLoading}
                                    onClick={handleDownloadCertificate}
                                />
                        }
                        
                        <PrimaryButton
                            onClick={handleStartButton}
                            isLoading={isLoading}
                            text={
                                !isLoading ?
                                    data.course_progress.status === "Not Started" ?
                                        <label>Start</label>
                                        :
                                        data.course_progress.status === "In Progress" ?
                                            <label>Continue</label>
                                            :
                                            data.course_progress.status === "Completed" &&
                                            <label>Start Again</label>
                                    :
                                    <span>N/A</span>
                            }
                        />
                    </div>
                </div>
                
                <div>
                    <div className='row academic-detail-courses-main-container'>
                        {
                            isLoading ? 
                            <div className='academic-courses-loader-div'>
                                <Spinner animation="border" role="status" className='academic-courses-loader'>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            :
                            <>
                                <div className='col-sm-2 academic-detail-course-title-img-col'>
                                    <img src={data.image} className="academic-detail-course-title-img" alt='course-details'/>
                                </div>
                                <div className='col-sm-5'>
                                    <div className='row academic-detail-course-title-col'>
                                        <div className='col-sm-4'>
                                            <label className='academic-detail-course-title-label'>Course Name:</label>
                                        </div>
                                        <div className='col'>
                                            <label className='academic-detail-course-title-value'>{data.name}</label>
                                        </div>
                                    </div>
                                    <div className='row academic-detail-course-title-col'>
                                        <div className='col-sm-4'>
                                            <label className='academic-detail-course-title-label'>Level:</label>
                                        </div>
                                        <div className='col'>
                                            <label className='academic-detail-course-title-value'>{data.level}</label>
                                        </div>
                                    </div>
                                    <div className='row academic-detail-course-title-col'>
                                        <div className='col-sm-4'>
                                            <label className='academic-detail-course-title-label'>Category:</label>
                                        </div>
                                        <div className='col'>
                                            <label className='academic-detail-course-title-value'>{data.category_name}</label>
                                        </div>
                                    </div>
                                    <div className='row academic-detail-course-title-col'>
                                        <div className='col-sm-4'>
                                            <label className='academic-detail-course-title-label'>Sub Category:</label>
                                        </div>
                                        <div className='col'>
                                            <label className='academic-detail-course-title-value'>{data.sub_category_name}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='row academic-detail-course-title-col'>
                                        <div className='col-sm-4'>
                                            <label className='academic-detail-course-title-label'>Status:</label>
                                        </div>
                                        <div className='col'>
                                            <label className='academic-detail-course-title-value'>{data.course_progress.status}</label>
                                        </div>
                                    </div>
                                    {
                                        data.course_progress.status === "In Progress" &&
                                            <div className='row academic-detail-course-title-col'>
                                                <div className='col-sm-4'>
                                                    <label className='academic-detail-course-title-label'>Lessons:</label>
                                                </div>
                                                <div className='col'>
                                                    <label className='academic-detail-course-title-value'>{data.course_progress.lesson_count} Completed</label>
                                                </div>
                                            </div>
                                    }  
                                </div>  
                            </>
                        }
                    </div>
                    <div className="row">
                        <div className="col-sm-7">
                            <div className='academic-detail-courses-main-container academic-detail-courses-container-left'>
                                <h5>Description</h5>
                                <hr className="academic-detail-courses-border" />
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: data.description }} />
                                }
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <div className='academic-detail-courses-main-container'>
                                <h5>Table of Content</h5>
                                <hr className="academic-detail-courses-border" />
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <div>
                                        <h4 className="academic-detail-courses-table-heading">{data.name}</h4>
                                        <div className="row academic-detail-courses-table-row">
                                            <div className="col-sm-1">
                                                <i className="bi bi-clock-fill academic-detail-courses-table-icon"></i>
                                            </div>
                                            <div className="col academic-detail-courses-table-label">
                                                Duration:&#160;&#160;&#160;
                                                <label className="academic-detail-courses-table-value">{data.duration} Hours</label>
                                            </div>
                                        </div>
                                        <div className="row academic-detail-courses-table-row">
                                            <div className="col-sm-1">
                                                <i className="bi bi-book-fill academic-detail-courses-table-icon"></i>
                                            </div>
                                            <div className="col academic-detail-courses-table-label">
                                                Chapters:&#160;&#160;&#160;
                                                <label className="academic-detail-courses-table-value">{data.chapter_count}</label>
                                            </div>
                                        </div>
                                        <div className="row academic-detail-courses-table-row">
                                            <div className="col-sm-1">
                                                <i className="bi bi-file-earmark-fill academic-detail-courses-table-icon"></i>
                                            </div>
                                            <div className="col academic-detail-courses-table-label">
                                                Lessons:&#160;&#160;&#160;
                                                <label className="academic-detail-courses-table-value">{data.lesson_count}</label>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className='academic-detail-courses-main-container'>
                                <h5>Course Summary</h5>
                                <hr className="academic-detail-courses-border" />
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: data.summary }} />
                                }
                            </div>
                        </div>
                    </div>
                    
                    
                    <div className='academic-detail-courses-main-container'>
                        <h5>Curriculum</h5>
                        <hr className="academic-detail-courses-border" />
                        {
                            isLoading ?
                            <div className='academic-courses-loader-div'>
                                <Spinner animation="border" role="status" className='academic-courses-loader'>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            :
                            data ?
                                <Accordion>
                                    {data.chapters.map((chapter, index) => {
                                        return (
                                            <Accordion.Item className='academic-detail-courses-chapter' key={chapter.id} eventKey={index}>
                                                <Accordion.Header>{chapter.name}</Accordion.Header>
                                                <Accordion.Body>
                                                    <Accordion>
                                                        {chapter.lessons.map((lesson, index) => { 
                                                            return (
                                                                <Card key={lesson.id} className='academic-detail-courses-lesson'>
                                                                    <Card.Body>
                                                                        <Card.Text>
                                                                            <div className='row'>
                                                                                <div className='col'>
                                                                                    <label>{lesson.name}</label>
                                                                                </div>
                                                                                <div className='col academic-detail-courses-lesson-duration'>
                                                                                    <label>{lesson.duration} minutes</label>
                                                                                </div>
                                                                            </div>
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            );
                                                        })}
                                                    </Accordion>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        );
                                    })}
                                </Accordion>
                                :
                                <></>
                            }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AcademicDetailCourse;
